import {
  RepositorioBaseComFiltragemDeLeitura,
  OpcoesRepositorioBaseComFiltragemDeLeitura,
} from "@/http"
import { AxiosPromise, AxiosRequestHeaders } from "axios"
import { ResultadoApiGET } from "@/types/api"
import {
  Atividade,
  AtividadesParams,
  AtualizarAtividade,
  CriarAtividade,
  IniciarAtividadeRealizada,
  FinalizarAtividadePlanejada,
  IniciarAtividadeRealizadaNaoPlanejada,
  AtividadeSimples,
} from "./atividades.modelos"

class AtividadesRealizadasRepositorio extends RepositorioBaseComFiltragemDeLeitura {
  public constructor(
    opcoesRepositorio: OpcoesRepositorioBaseComFiltragemDeLeitura = {}
  ) {
    super({
      ...opcoesRepositorio,
      parametrosPadrao: {
        "ordenar-por": ["desc.ativo"],
      },
    })
  }
  // se possível evitar de utilizar a rota frontend e utilizar a não frontend
  public listarAtividadesRealizadasFrontend = (
    params?: AtividadesParams,
    headers: AxiosRequestHeaders = {}
  ): Promise<ResultadoApiGET<Atividade>> =>
    this.instance.get("/api/frontend/atividades-realizadas", { params, headers })

  public listarAtividadesRealizadas = (
    params?: AtividadesParams
  ): Promise<ResultadoApiGET<AtividadeSimples>> =>
    this.instance.get("/api/atividades-realizadas", { params })

  public deletarAtividade = (params: AtividadesParams): AxiosPromise<void> =>
    this.instance.delete(`/api/atividades-realizadas/${params.id}`)

  public desconsiderarAtividade = (
    params: AtividadesParams
  ): AxiosPromise<void> =>
    this.instance.post(`/api/atividades-realizadas/${params.id}/desativar`)

  public criarAtividadeRealizada = (
    atividade?: CriarAtividade
  ): Promise<{ id: string }> =>
    this.instance.post("/api/atividades-realizadas", atividade)

  public atualizarAtividadeRealizada = (
    id?: string,
    atividade?: AtualizarAtividade
  ): Promise<{ id: string }> =>
    this.instance.patch("/api/atividades-realizadas/" + id, atividade)

  public baixarRelatorioDeAtividades = (urlArquivo: string): Promise<Blob> =>
    this.instance.get("/api/relatorios/baixar/" + urlArquivo, {
      responseType: "blob",
    })

  public iniciarAtividadeRealizada = (
    atividade?: IniciarAtividadeRealizada | IniciarAtividadeRealizadaNaoPlanejada
  ): Promise<{ id: string }> =>
    this.instance.post("/api/atividades-realizadas/iniciar", atividade)

  public finalizarAtividadePlanejada = (
    idAtividade?: string,
    atividade?: FinalizarAtividadePlanejada
  ): Promise<{ id: string }> =>
    this.instance.post(
      `/api/atividades-realizadas/${idAtividade}/finalizar`,
      atividade
    )

  public importarAtividadesPlanejadas = (arquivo?: File): Promise<Blob> => {
    if (!arquivo) { return Promise.reject("Arquivo não informado") }
    const formData = new FormData()
    formData.append('arquivo', arquivo)

    return this.instance.post("/api/importacoes/atividades-planejadas", formData, {
      responseType: 'blob',
    })

  }
}

export default AtividadesRealizadasRepositorio
